import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Inga Linda Toma</p>
      <Link to="/privacy" className="privacy-link">
        Privacy Policy
      </Link>
    </footer>
  );
};

export default Footer;
